module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Minus-6d2b8f18f36130ad9402b1e3c4a684d0.svg";